var render = function () {
  var _vm$member, _vm$member2, _vm$member3, _vm$member4, _vm$member4$plan_deta, _vm$member5, _vm$member6;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "termPolicyModal",
      "modal-class": "client-details-modal",
      "centered": "",
      "size": "md",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": ""
    },
    on: {
      "hidden": _vm.resetForm,
      "shown": _vm.getTermedDates
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('termPolicyModal');
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "form-part"
  }, [_c('div', {
    staticClass: "title-text text-center mb-3"
  }, [_c('h5', [_c('strong', [_vm._v("Terminate/Withdraw Policy")])])]), _c('div', {
    staticClass: "plan-details mb-4"
  }, [_c('p', [_c('strong', [_vm._v("PolicyID:")]), _vm._v(" " + _vm._s((_vm$member = _vm.member) === null || _vm$member === void 0 ? void 0 : _vm$member.policy_id))]), _c('p', [_c('strong', [_vm._v("Name:")]), _vm._v(" " + _vm._s((_vm$member2 = _vm.member) === null || _vm$member2 === void 0 ? void 0 : _vm$member2.first_name) + " " + _vm._s((_vm$member3 = _vm.member) === null || _vm$member3 === void 0 ? void 0 : _vm$member3.last_name) + " ")]), _c('p', [_c('strong', [_vm._v("Plan Details:")]), _vm._v(" " + _vm._s((_vm$member4 = _vm.member) === null || _vm$member4 === void 0 ? void 0 : (_vm$member4$plan_deta = _vm$member4.plan_details[0]) === null || _vm$member4$plan_deta === void 0 ? void 0 : _vm$member4$plan_deta.plan_title) + " ")])]), _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitNote.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    attrs: {
      "for": "actionPerformed"
    }
  }, [_vm._v("Choose Action to be performed "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('b-form-select', {
    staticClass: "memberSearch-field mt-2",
    attrs: {
      "id": "actionPerformed",
      "options": _vm.actionOptions
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('option', {
          attrs: {
            "value": "",
            "disabled": "",
            "selected": ""
          }
        }, [_vm._v("Select an action ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.actionPerformed,
      callback: function callback($$v) {
        _vm.actionPerformed = $$v;
      },
      expression: "actionPerformed"
    }
  }), _vm.$v.actionPerformed.$dirty && !_vm.$v.actionPerformed.required ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" Action is required. ")]) : _vm._e()], 1), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    attrs: {
      "for": "effectiveDate"
    }
  }, [_vm._v("Terminate/Withdraw Date "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('b-form-select', {
    staticClass: "memberSearch-field mt-2",
    attrs: {
      "id": "effectiveDate",
      "disabled": _vm.actionPerformed === 'withdraw'
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('option', {
          attrs: {
            "value": "",
            "disabled": "",
            "selected": ""
          }
        }, [_vm._v("Select an Terminate/Withdraw Date")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.tdate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tdate", $$v);
      },
      expression: "form.tdate"
    }
  }, [_vm.actionPerformed === 'withdraw' ? _c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm$member5 = _vm.member) === null || _vm$member5 === void 0 ? void 0 : _vm$member5.effective_date
    }
  }, [_vm._v(" " + _vm._s((_vm$member6 = _vm.member) === null || _vm$member6 === void 0 ? void 0 : _vm$member6.effective_date) + " ")]) : _vm._l(_vm.statusOptions, function (option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option
      }
    }, [_vm._v(" " + _vm._s(option) + " ")]);
  })], 2), _vm.$v.form.tdate.$dirty && !_vm.$v.form.tdate.required ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" Effective date is required. ")]) : _vm._e()], 1), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    attrs: {
      "for": "action"
    }
  }, [_vm._v("Action "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('b-form-input', {
    staticClass: "memberSearch-field mt-2",
    attrs: {
      "id": "action",
      "value": _vm.form.action,
      "disabled": ""
    }
  }), _vm.$v.form.action.$dirty && !_vm.$v.form.action.required ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" Action type is required. ")]) : _vm._e()], 1), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Reason "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('b-form-textarea', {
    staticClass: "memberSearch-field mt-2",
    attrs: {
      "id": "reason",
      "rows": "3",
      "placeholder": "Enter your reason"
    },
    model: {
      value: _vm.form.text,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "text", $$v);
      },
      expression: "form.text"
    }
  }), _vm.$v.form.text.$dirty && !_vm.$v.form.text.required ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" Reason is required. ")]) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('button', {
    staticClass: "group-univ-btn text-center",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitting
    }
  }, [_vm.isSubmitting ? _c('span', {
    staticClass: "spinner-border spinner-border-sm me-1"
  }) : _vm._e(), _vm._v(" Submit ")])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }